import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { CustomerSelector } from "redux/selector/customer-selector";
import { Routes } from "const";
import InvestorPropertyRoute from "../InvestorPropertyRoute";

const PwmRoute = ({ component: Component, location, condition, ...rest }) => {
  const isPwmUser = useSelector(CustomerSelector.isPwmUser);
  return (
    <Route
      {...rest}
      render={() =>
        isPwmUser ? (
          <InvestorPropertyRoute path="" component={Component} exact />
        ) : (
          <Redirect
            to={{ pathname: Routes.Restriction, state: { from: location } }}
          />
        )
      }
    />
  );
};

export default PwmRoute;
